import React, { useContext } from 'react';
import {
  Connect,
  PropsFromRedux,
} from './AddOneDecisionToFolderDropdownContainer';
import { AddToFoldersDropdown } from './AddToFoldersDropdown';
import {
  FoldersToastDecisionAdded,
  FoldersToastFolderAlreadyAdded,
  FoldersToastFolderCreated,
} from '../toast/FoldersToast';
import { FoldersDropdownContext } from './FoldersDropdownContext';
import { folderToast } from '../toast/folderToast';
import { FolderSelectionType } from './foldersDropdown.types';

type Props = {
  isLoading: boolean;
} & PropsFromRedux;

export const RawAddOneDecisionToFolderDropdown: React.FC<Props> = ({
  isLoading,
  createNewFolder,
  saveInFolder,
}) => {
  const { closeDropdown } = useContext(FoldersDropdownContext);
  const onFolderSelectCallback = ({
    folder,
    searchActive,
  }: {
    folder: FolderSelectionType;
    searchActive: boolean;
  }) => {
    closeDropdown();
    if (!folder.selected) {
      const { folderKey } = folder;
      saveInFolder({ searchActive, folderKey });
      folderToast(
        <FoldersToastDecisionAdded
          to={`/dossiers/${folder.folderKey}?source=folder-toaster-create`}
        >
          {folder.title}
        </FoldersToastDecisionAdded>,
      );
    } else {
      folderToast(
        <FoldersToastFolderAlreadyAdded
          to={`/dossiers/${folder.folderKey}?source=folder-toaster-already`}
        >
          {folder.title}
        </FoldersToastFolderAlreadyAdded>,
      );
    }
  };

  const createNewFolderCallback = async ({
    title,
    source,
  }: {
    title: string;
    source: string;
  }) => {
    const folder = await createNewFolder({ title, source });
    closeDropdown();
    if (folder)
      folderToast(
        <FoldersToastFolderCreated
          to={`/dossiers/${folder.folderKey}?source=folder-toaster-new-folder`}
        >
          {folder.title}
        </FoldersToastFolderCreated>,
      );
  };

  return (
    <AddToFoldersDropdown
      isLoading={isLoading}
      onFolderSelect={onFolderSelectCallback}
      onFolderCreate={createNewFolderCallback}
    />
  );
};

export const AddOneDecisionToFolderDropdown = Connect(
  RawAddOneDecisionToFolderDropdown,
);
